import styled from 'styled-components'

import { ColumnFlex, hideWhenNoChildren } from 'components/common/genericStyles'

export const ModesContainer = styled.div`
    position: absolute;
    ${ColumnFlex}

    top: 100%;
    right: 25%;

    z-index: 30;
    width: 250px;
    height: max-content;
    background: #36383c;
    text-align: center;
    border-radius: 6px;
    padding: 8px 0;
    transform: translate(0px, 10px);

    & > div {
        :hover {
            background: #ffffff24;
        }
    }
`
export const Container = styled.div`
    position: relative;
    height: 100%;
    ${props => props.rightControl && 'width: 100%;'}
    ${hideWhenNoChildren}
`
